import React, { useContext, useEffect, useRef, useState } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import ScrapsGrid from './ScrapsGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import useScrapsPresenter from './ScrapsPresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { strToDate, DATE_FORMAT, todayLastYearDate } from '../../utils/DateUtils';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { userInfo } = useContext(LoginContext);
  const {
    selectedSupplier,
    setSelectedSupplier,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    supplierCode,
    setSupplierCode,
    contract,
    setContract,
    delivery,
    setDelivery,
    validateAndSearch,
    cleanFilters,
  } = filtersProps;

  const isScrapper = userInfo.role.includes("CHATARRERO");

  return (
    <div className={classes.filters}>
      {!isScrapper && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}

      <TextField
        style={{ width: 150 }}
        margin="dense"
        id="delivery"
        label="Entrega"
        onChange={e => setDelivery(e.target.value)}
        value={delivery}
      />

      <CustomDatePicker2 value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker2 value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />

      {!isScrapper && <TextField
        style={{ width: 150 }}
        margin="dense"
        id="supplierCode"
        label="Código Proveedor"
        onChange={e => setSupplierCode(e.target.value)}
        value={supplierCode}
      />}
      
      <TextField
        style={{ width: 150 }}
        margin="dense"
        id="contract"
        label="Contrato"
        onChange={e => setContract(e.target.value)}
        value={contract}
      />
      
      
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const CustomDatePicker2 = ({
  value,
  setValue,
  minDate,
  maxDate,
  label,
  disablePast,
  readOnly,
  disabled,
  style,
  disableMinDate,
  ...restProps
}) => {
  const handleBlur = e => {
    const dateValue = e.target.value;
    setValue(dateValue.isBlank() ? null : strToDate(dateValue));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        style={{ width: 140, ...style }}
        disableToolbar
        disablePast={disablePast}
        disabled={disabled}
        autoOk
        variant="inline"
        format={DATE_FORMAT}
        margin="dense"
        invalidDateMessage="Fecha incorrecta"
        id={`date-picker-inline-${label}`}
        label={label || 'Fecha'}
        minDate={readOnly || minDate || disableMinDate ? minDate : undefined}
        maxDate={maxDate || undefined}
        value={value}
        onChange={() => undefined}
        onAccept={setValue}
        onBlur={!readOnly ? handleBlur : undefined}
        inputProps={{ readOnly: !!readOnly }}
        KeyboardButtonProps={{
          disabled: !!readOnly || !!disabled,
          'aria-label': 'change date',
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  );
};

const Scraps = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useScrapsPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <ScrapsGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default Scraps;